module.exports = __webpack_public_path__ + "static/img/img_logo_11.d94db184.png";